import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppRoleAssignment } from "src/App/api/APIClient";

export default function InviteExternUser({
    roles,
    onAdd,
}: {
    roles: AppRoleAssignment[];
    onAdd: (payload: { email: string; roleId: string; allowAccess: boolean }) => void;
}) {
    const { t } = useTranslation("project");

    const [email, setEmail] = useState("");
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const [grantInitialPermissions, setGrantInitialPermissions] = useState(true);

    const isFormValid = email.trim() !== "" && email.includes("@") && !!selectedRoleId;

    const handleAdd = () => {
        if (!isFormValid) return;
        onAdd({ email, roleId: selectedRoleId, allowAccess: grantInitialPermissions });
        setEmail("");
        setSelectedRoleId("");
        setGrantInitialPermissions(true);
    };

    return (
        <Box role="tabpanel" id="user-tabpanel-1" aria-labelledby="user-tab-1" sx={{ mt: 2 }}>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} padding={1}>
                        <TextField
                            id="email"
                            type="email"
                            label={t("userController.invite.emailLabel")}
                            placeholder={t("userController.invite.emailPlaceholder")}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            helperText={t("userController.invite.emailHelper")}
                            fullWidth
                            required
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2} padding={1}>
                    <Grid item xs={12} md={5}>
                        <FormControl fullWidth>
                            <InputLabel id="role-invite-label">
                                {t("userController.invite.roleLabel")}
                            </InputLabel>
                            <Select
                                labelId="role-invite-label"
                                id="role-invite"
                                value={selectedRoleId}
                                label={t("userController.invite.roleLabel")}
                                onChange={(e) => setSelectedRoleId(e.target.value as string)}
                                required
                            >
                                {roles.map((role) => (
                                    <MenuItem key={role.id} value={role.principalId}>
                                        {role.principalDisplayName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={grantInitialPermissions}
                                    onChange={(e) => setGrantInitialPermissions(e.target.checked)}
                                />
                            }
                            label={t("userController.invite.enableInitialPerms")}
                        />
                    </Grid>
                </Grid>

                <Button
                    variant="contained"
                    onClick={handleAdd}
                    disabled={!isFormValid}
                    fullWidth
                    color={isFormValid ? "primary" : "inherit"}
                >
                    {t("userController.invite.addButton")}
                </Button>
            </Box>
        </Box>
    );
}
